<template>
  <div class="main-pages">
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <div
      class="w-100 d-flex flex-column justify-content-between align-items-center"
      style="padding: 24px; margin-top: 82px"
    >
      <span class="pageSteps card-styling">
        <p style="font-weight: 300; font-style: normal">Dashboard</p>
        <img
          style="margin: 0 17px"
          :src="require(`@/assets/images/svg/ícone-seta-direita-cinza.svg`)"
          alt=""
        />
        <p style="font-style: normal; font-weight: 500">Biblioteca</p>
      </span>
      <div id="divTable" style="margin-top: 32px">
        <section
          class="d-flex justify-content-between align-items-center w-100 flex-wrap"
        >
          <div
            style="
              background: #f0f2f8;
              border-radius: 8px;
              width: 310px;
              height: 42px;
              max-width: 310px;
            "
            class="d-flex align-items-center justify-content-between"
          >
            <InputSearch @onUpdate="(value) => libraryByName(value)" />
          </div>

          <button
            class="btn"
            data-bs-toggle="modal"
            data-bs-target="#modalUpload"
            style="
              background: var(--blue-medium);
              border-radius: 8px;
              color: var(--white);
              font-weight: 500;
              font-size: 16px;
              height: 48px;
              width: 193px;
              max-width: 193px;
            "
          >
            Upload
          </button>
        </section>
        <div class="table-responsive w-100">
          <table class="table align-middle">
            <thead class="thead">
              <tr style="height: 50px">
                <th>Mídia</th>
                <th>Categoria</th>
                <th>Responsável</th>
                <th>Associado em</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td>
                  <img
                    v-if="
                      item.urlMedia.includes('.jpg') ||
                      item.urlMedia.includes('.jpeg')
                    "
                    class="img-fluid img-table"
                    :src="item.urlMedia"
                    alt="Não renderizou"
                  />
                  <video
                    v-else
                    class="img-fluid img-table"
                    :src="item.urlMedia"
                  />
                </td>
                <td>{{ item.instagramLibraryCategory.name }}</td>
                <td>
                  {{ item.owner ? item.owner : "[nomeUsuário]" }}
                </td>
                <td>{{ currentDateTime(item) }}</td>
                <th>
                  <img
                    class="cursor-pointer"
                    :src="require(`@/assets/images/svg/icone-lixeira.svg`)"
                    style="margin-right: 20%"
                    alt=""
                    data-bs-toggle="modal"
                    data-bs-target="#modalExluir"
                    @click="
                      () => {
                        recebeID = item.id;
                      }
                    "
                  />
                  <img
                    class="cursor-pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#modalverPublicacao"
                    @click="
                      () => {
                        recebeEdicao = item;
                      }
                    "
                    :src="require(`@/assets/images/svg/icone-seta-lateral.svg`)"
                    alt=""
                  />
                </th>
              </tr>
            </tbody>
          </table>
          <Pagination
            :count="totalLibrary"
            :offset="offset"
            @firstPage="pagination('clickFirstPage')"
            @previousPage="pagination('clickPreviousPage')"
            @nextPage="pagination('clickNextPage')"
            @lastPage="pagination('clickLastPage')"
          />
        </div>
      </div>
    </div>
    <!-- Modal Submit -->

    <ModalUploadMidiaVue
      :category="category"
      :name="nome"
      :momento="momento"
      :setLoading="setLoading"
    />

    <div
      class="modal fade"
      data-bs-backdrop="false"
      id="modalverPublicacao"
      larger
      tabindex="1"
      aria-labelledby="modalverPublicacao"
      aria-hidden="true"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <form class="modal-content" @submit.prevent="editar">
          <div class="modal-header border-0 pb-0">
            <h6
              class="modal-title"
              style="
                font-style: normal;
                font-weight: 700;
                font-size: 24px;
                color: var(--grey-medium);
              "
            >
              Gerencie o seu template
            </h6>
          </div>

          <div class="modal-body mt-0 pt-0">
            <div class="d-flex col-12 flex-wrap-reverse">
              <div v-if="recebeEdicao.urlMedia" class="col-md-6 col-12">
                <img
                  v-if="
                    recebeEdicao?.urlMedia.includes('.jpg') ||
                    recebeEdicao?.urlMedia.includes('.jpeg')
                  "
                  :src="recebeEdicao.urlMedia"
                  style="min-width: 100%; min-height: 100%"
                  class="img-fluid"
                  alt=""
                />
                <video
                  v-else
                  :src="recebeEdicao.urlMedia"
                  style="min-width: 100%; min-height: 100%"
                  class="img-fluid"
                  controls
                />
              </div>
              <div class="col-md-6 col-12">
                <div class="table-responsive w-100">
                  <table class="table align-middle">
                    <thead class="thead">
                      <tr style="height: 50px">
                        <th class="th-template">Responsável</th>
                        <th class="th-template">Criado em</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="td-template">{{ recebeEdicao.owner }}</td>
                        <td class="td-template">
                          {{
                            formatDateTime(
                              recebeEdicao.instagramLibraryCategory.createdAt
                            )
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  <p class="th-template" style="margin-left: 9px">Categoria</p>
                  <select
                    class="select-categoria"
                    v-model="recebeEdicao.instagramLibraryCategoryId"
                    name=""
                    id=""
                    style="margin: 10px"
                  >
                    <option
                      v-for="item in category"
                      :key="item.id"
                      class="option-categoria"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div
            class="d-flex w-100 justify-content-center align-items-center"
            style="padding: 12px"
          >
            <button
              data-bs-dismiss="modal"
              aria-label="Close"
              style="
                border-radius: 8px;
                text-align: center;
                background-color: transparent;
                color: var(--blue-medium);
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                height: 56px;
                margin: 8px;
              "
              class="border-0 w-100"
            >
              Voltar
            </button>
            <button
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#modalverPublicacao"
              @click="
                () => {
                  recebeID = recebeEdicao.id;
                }
              "
              style="text-align: center; background: #ffb9b9; color: #e51717"
              class="btn-default m-1F"
            >
              Fechar
            </button>
            <button
              :disabled="fileLarge"
              type="submit"
              style="
                border-radius: 8px;
                text-align: center;
                background-color: var(--blue-medium);
                color: var(--white);
              "
              class="btn-default m-1"
            >
              Salvar
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Modal excluir -->
    <div
      class="modal fade"
      data-bs-backdrop="false"
      id="modalExluir"
      tabindex="1"
      aria-labelledby="modalExluir"
      aria-hidden="true"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <form
        class="modal-dialog modal-dialog-centered"
        @submit.prevent="deletar"
      >
        <div class="modal-content">
          <div class="modal-header border-0 pb-0">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body mt-0 pt-0">
            <h6
              class="modal-title"
              id="modalSelectedStoreLabel"
              style="font-style: normal; font-weight: 700; font-size: 27px"
            >
              Tem certeza?
            </h6>
            <p
              style="
                font-family: 'Roboto';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 19px;

                color: #80848a;
              "
            >
              Ao excluir esse template, ele não ficará disponível para novas
              publicações nos perfis do instagram
            </p>
          </div>
          <div
            class="d-flex w-100 justify-content-center align-items-center"
            style="padding: 12px"
          >
            <button
              type="button"
              style="
                border-radius: 8px;
                text-align: center;
                background-color: var(--blue-light);
                color: var(--blue-medium);
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                height: 56px;
                margin: 8px;
              "
              class="border-0 w-100"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              Voltar
            </button>
            <button
              type="submit"
              style="
                border-radius: 8px;
                text-align: center;
                background-color: #e51717;
                color: white;
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                height: 56px;
                margin: 8px;
              "
              class="border-0 w-100"
            >
              Excluir
            </button>
          </div>
        </div>
      </form>
    </div>

    <input
      type="hidden"
      id="clickModalTemplateExcluido"
      data-bs-toggle="modal"
      data-bs-target="#modalTemplateExcluido"
    />

    <!-- Modal concluido -->
    <div
      class="modal fade"
      data-bs-backdrop="false"
      id="modalTemplateExcluido"
      tabindex="1"
      aria-labelledby="modalTemplateExcluido"
      aria-hidden="true"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0 pb-0">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body mt-0 pt-0">
            <h6
              class="modal-title"
              style="font-style: normal; font-weight: 700; font-size: 27px"
            >
              Template excluído
            </h6>
            <p
              style="
                font-family: 'Roboto';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 19px;

                color: #80848a;
              "
            >
              O template foi excluído com sucesso
            </p>
          </div>
          <div
            class="d-flex w-100 justify-content-center align-items-center"
            style="padding: 12px"
          >
            <button
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              style="
                border-radius: 8px;
                text-align: center;
                background-color: var(--blue-light);
                color: var(--blue-medium);
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                height: 56px;
                margin: 8px;
              "
              class="border-0 w-100"
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import InputSearch from "@/components/InputSearch.vue";
import Pagination from "@/components/Pagination.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import moment from "moment/moment";
import Loading from "vue-loading-overlay";
import formatting from "../plugins/formatting";
import ModalUploadMidiaVue from "../components/ModalUploadMidia.vue";

export default {
  name: "Library",
  components: { InputSearch, Pagination, Loading, ModalUploadMidiaVue },
  data() {
    return {
      offset: 0,
      totalLibrary: 0,
      nameToSearch: "",
      items: [],
      instagramLibraryCategoryId: 0,
      user: {},
      momento: moment().format("DD/MM/YYYY hh:mm:ss"),
      category: [
        {
          id: 0,
        },
      ],
      nome: ref(""),
      base64String: "",
      imageBase64Stringsep: "",
      itemSelected: 1,
      recebeID: 0,
      recebeEdicao: {
        instagramLibraryCategory: {},
      },
      isLoading: false,
    };
  },
  async created() {
    this.isLoading = true;

    await this.getLibraryByPagination({
      action: "clickFirstPage",
      offset: 0,
      name: this.nameToSearch,
      limit: 5,
    }).then((response) => {
      this.totalLibrary = response.data.count;
      this.items = response.data.data;
    });

    await this.getCategoria();

    await this.getUserByEmail().then((response) => {
      this.user = response.data.data[0];
      this.nome = this.user.name;
    });

    this.isLoading = false;
  },
  computed: {
    ...mapGetters(["getOffset", "baseImg", "fileLarge"]),
  },

  methods: {
    ...mapActions([
      "getLibraryByPagination",
      "getcategory",
      "PostLibrary",
      "DeleteLibrary",
      "getLibrary",
      "setBaseImg",
      "PutLibrary",
      "getUserByEmail",
    ]),
    ...mapMutations(["SET_OFFSET"]),

    libraryByName: function libraryByName(name) {
      this.nameToSearch = name;

      if (this.nameToSearch != "") {
        let objThis = this;

        clearTimeout(libraryByName);

        setTimeout(function () {
          objThis.pagination("clickFirstPage");
        }, 500);
      } else {
        this.pagination("clickFirstPage");
      }
    },

    pagination(action) {
      const data = {
        action: action,
        offset: 0,
        name: this.nameToSearch,
        limit: 5,
      };
      switch (action) {
        case "clickFirstPage":
          this.isLoading = true;
          this.offset = 0;
          this.SET_OFFSET(0);
          this.getLibraryByPagination(data).then((response) => {
            this.totalLibrary = response.data.count;
            this.items = response.data.data;
          });

          this.isLoading = false;

          break;
        case "clickPreviousPage": {
          this.isLoading = true;
          this.SET_OFFSET(this.getOffset - data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getLibraryByPagination(data).then((response) => {
            this.items = response.data.data;
          });
          this.isLoading = false;
          break;
        }
        case "clickNextPage": {
          this.isLoading = true;
          this.SET_OFFSET(this.getOffset + data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getLibraryByPagination(data).then((response) => {
            this.items = response.data.data;
          });

          this.isLoading = false;

          break;
        }
        case "clickLastPage": {
          this.isLoading = true;
          let lastPage;

          if (this.totalLibrary % data.limit === 0) {
            lastPage = this.totalLibrary - data.limit;
          } else {
            lastPage = Math.floor(this.totalLibrary / data.limit) * data.limit;
          }

          this.SET_OFFSET(lastPage);

          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getLibraryByPagination(data).then((response) => {
            this.items = response.data.data;
          });

          this.isLoading = false;

          break;
        }
        default:
          break;
      }
    },

    async getCategoria() {
      try {
        const response = await this.getcategory();
        if (response.status === 200) {
          this.category = response.data;
        } else {
          console.log(response);
        }
      } catch (error) {
        console.log(error);
      }
    },

    setLoading(value) {
      this.isLoading = value;
    },

    currentDateTime(timestamp) {
      return moment(timestamp.createdAt).format("DD/MM/YY");
    },
    resetModal() {
      document.getElementById("apresentar-imagem").innerHTML = "";
      this.momento = moment().format("DD/MM/YYYY hh:mm:ss");
      this.itemSelected = 1;
    },
    handleFile(file) {
      this.base64String = file.result.replace("data:", "").replace(/^.+,/, "");
    },

    // async imageUploaded() {
    //   //refatorar função imageUploaded
    //   var file = document.querySelector("input[type=file]")["files"][0];

    //   var reader = new FileReader();

    //   reader.onload = () => {
    //     this.base64String = reader.result
    //       .replace("data:", "")
    //       .replace(/^.+,/, "");

    //     var novaImagem = document.createElement("img");
    //     novaImagem.style.width = "100%";
    //     novaImagem.style.height = "100%";

    //     novaImagem.src = reader.result;

    //     document.getElementById("apresentar-imagem").innerHTML =
    //       novaImagem.outerHTML;
    //   };
    //   reader.readAsDataURL(file);
    // },

    async editar() {
      try {
        this.PutLibrary({
          id: this.recebeEdicao.id,
          instagramLibraryCategoryId:
            this.recebeEdicao.instagramLibraryCategoryId,
        });
        //remover reload e incluir chamada getLibraryByPagination
        document.location.reload(true);
      } catch (error) {
        console.log(error);
      }
    },

    async deletar() {
      this.isLoading = true;
      try {
        const response = await this.DeleteLibrary({
          id: this.recebeID,
        });
        if (response.status === 200) {
          await this.getLibraryByPagination({
            action: "clickFirstPage",
            offset: 0,
            name: this.nameToSearch,
            limit: 5,
          })
            .then((response) => {
              this.totalLibrary = response.data.count;
              this.items = response.data.data;
              this.isLoading = false;
            })
            .catch((err) => {
              console.log(err);
              this.isLoading = false;
            });

          document.getElementById("clickModalTemplateExcluido").click();
        } else {
          //TODO: Exibir msg de erro no modal de finalização
          console.log("Não foi possível deletar template!");
          this.isLoading = false;
        }
      } catch (error) {
        //TODO: Exibir msg de erro no modal de finalização
        console.log("Erro ao deletar template!", error);
        this.isLoading = false;
      }
    },

    async submit() {
      try {
        await this.PostLibrary({
          image: this.base64String,
          instagramLibraryCategoryId: this.itemSelected,
        });
        //TODO: remover reload e incluir chamada getLibraryByPagination e implementar loading
        document.location.reload(true);
      } catch (erro) {
        console.log(erro);
      }
    },

    formatDateTime(value) {
      const newValue = formatting.formatDateTime(value);
      return newValue;
    },
  },
};
</script>
<style scoped>
input[type="file"] {
  display: none;
}
.btnNotMultipleImages {
  background-color: transparent;
  border: 1px solid var(--blue-medium);
  border-radius: 8px;
  color: var(--blue-medium);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  padding: 5px 30px;
  cursor: pointer;
  text-align: center;
}

#label-attach-image {
  background-color: #d3e7fb;
  border-radius: 8px;
  color: #2485ea;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  padding: 15px 30px;
  cursor: pointer;
}
.select-categoria {
  width: 356px;
  height: 38px;
  margin-left: 10px;
  background: #f0f2f8;
  border-radius: 4px;
  border: none;
}
img,
svg {
  vertical-align: middle;
  max-width: 100%;
  max-height: 100%;
}
.option-categoria {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #383838;
}

.th-template {
  border-bottom-width: 0px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: var(--grey-medium);
}

.td-template {
  border-bottom-width: 0px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.03em;
  color: #383838;
}

h6 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 34px;
  line-height: 40px;

  color: #383838;
}
.img-table {
  border-radius: 8px;
  max-width: 64px;
  height: 54px;
}
.button-filtrar {
  background: #2485ea;
  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 450;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  border: none;
  height: 42px;
  width: 100%;
  padding: 13px 0px 0px 0px;
  cursor: pointer;
}
#section-personal-data {
  margin: 0 12px 0 0;
}
#section-security {
  margin: 0 0 0 12px;
}
.input-new-password-responsive {
  margin: 0 12px 0 0;
}
.input-confirm-new-password-responsive {
  margin: 0 0 0 12px;
}
#divTable {
  width: 100%;
  box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.07);
  border-radius: 12px;
  padding: 24px 16px 24px 32px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  background-color: var(--white);
  margin-bottom: 22px;
}
img.img-postagem {
  margin: 10px 12px;
}
.table {
  margin: 0;
}
.table td,
.table th {
  vertical-align: middle;
}
.table th {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: var(--grey-medium);
  text-align: start;
}
thead.thead {
  border-color: var(--blue-light);
}
tbody tr:nth-last-child(even) {
  border-top: none !important;
  border-bottom-color: var(--blue-light);
}
tbody tr:nth-last-child(odd) {
  border-top: none !important;
  border-bottom-color: var(--blue-light);
}
footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.table {
  margin: 0;
}
.table td,
.table th {
  vertical-align: middle;
}
.table th {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: var(--grey-medium);
  text-align: start;
}
thead.thead {
  border-color: var(--blue-light);
}
tbody tr:nth-last-child(even) {
  border-top: none !important;
  border-bottom-color: var(--blue-light);
}
tbody tr:nth-last-child(odd) {
  border-top: none !important;
  border-bottom-color: var(--blue-light);
}

@media only screen and (max-width: 410px) {
  #label-attach-image {
    font-size: 13px;
    padding: 12px 14px;
  }
}
@media only screen and (max-width: 700px) {
  #section-personal-data > div,
  #section-security > div {
    flex-direction: column;
  }
  .input-confirm-new-password-responsive,
  .input-new-password-responsive {
    margin: 0;
  }
}
@media only screen and (max-width: 768px) {
  .session-one {
    flex-direction: column;
  }
  #section-security {
    margin: 12px 0 0 0;
  }
  #section-personal-data {
    margin: 0 0 12px 0;
  }
}

.fileinput {
  width: 80%;
  max-width: 1000px;
  margin: 0 auto;
}
#imgpreview {
  width: 100%;
  height: auto;
  margin-bottom: 2rem;
}
#fileSelector {
  font-size: 1.3rem;
  padding: 0.5rem 1rem;
  background: hsl(50, 100%, 50%);
  font-family: Avenir, sans-serif;
  border-radius: 5px;
  cursor: pointer;
  display: block;
  margin: 1rem auto;
}
</style>
